<div class="width-1100">

  <mat-card>

    <mat-toolbar class="toolbar-top">

      <div class='title' style='padding: 10px;'>
        CAEX - Nova Inscrição
      </div>

      <button mat-button (click)='goBack()'>
        <mat-icon>arrow_back</mat-icon>
      </button>

    </mat-toolbar>

  </mat-card>

  <mat-card>

    <div style="padding:10px 0 10px 0;">
      {{_caexService.currentProduct.name.trim().toUpperCase()}}
    </div>

  </mat-card>

  <div class='div-progress'>
    <mat-progress-bar [ngClass]="{hidden: !spinner}" color='warn' mode="indeterminate">
    </mat-progress-bar>
  </div>

  <mat-card>

    <div class='order-field'>{{_caexService.currentMember.name}}</div>
    <div class='order-field'>{{_caexService.currentMember.subCategory.name}}</div>

<!--_caexService.currentMember.subCategory.name-->
    <!--
    <div *ngIf="_caexService.currentMember.situation == '0'" class='order-field'>
      Quite
    </div>
    <div *ngIf="_caexService.currentMember.situation == '1'" class='order-field'>
      Não quite
    </div>
    <div *ngIf="_caexService.currentMember.situation == '2'" class='order-field'>
      Isento
    </div>
    <div *ngIf="_caexService.currentMember.situation == '1'" class='order-field-obs'>
      {{_caexService.currentMember.obs}}
    </div>
    -->

  </mat-card>

  <mat-card>

    <div style="display: flex; flex-direction: row;">

      <form [formGroup]="orderForm" style="width: 240px;">

        <mat-form-field class="value-width">
          <input matInput type="number" [errorStateMatcher]="matcher" [formControl]="orderForm.controls.value"
            placeholder="Valor" autocomplete="off">
          <mat-error *ngIf="orderForm.controls.value.hasError('required')">
            O valor é obrigatório
          </mat-error>
        </mat-form-field>

      </form>

      <div>
        <button mat-raised-button (click)='getOption()' class='order-button' [disabled]="orderForm.invalid">
          Inscrever
        </button>
      </div>

    </div>

  </mat-card>


  <!--
  <mat-card *ngIf="_caexService.currentMember.situation == '1'">

    <div class='order-values'>

      <div class='order-line'>
        <div class='order-field-label'>
          Débito:
        </div>
        <div class='order-field-value'>
          R$ {{ value_balance | currency:'BRL':'':'1.2-2'}}
        </div>
      </div>

      <div class='order-line'>
        <div class='order-field-label'>
          Inscrição:
        </div>
        <div class='order-field-value'>
          R$ {{ value_subscription | currency:'BRL':'':'1.2-2' }}
        </div>
      </div>

      <div class='order-line'>
        <div class='order-field-label'>
          Total
        </div>
        <div class='order-field-value-total'>
          R$ {{ op1_value_total | currency:'BRL':'':'1.2-2' }}
        </div>
      </div>

      <div class='order-line'>
        <div class='order-field-label'>

        </div>
        <div class='order-field-value-total'>
          USD$ {{ op1_value_total_us | currency:'BRL':'':'1.2-2' }}
        </div>
      </div>

      <div class='option-button'>
        <button mat-raised-button (click)='getOptionOne()' class='order-button'>
          Inscrever 1
        </button>
      </div>

    </div>

  </mat-card>
  -->

  <!--
  <mat-card *ngIf="_caexService.currentMember.situation == '1'">

    <div class='order-values'>

      <div class='order-line'>
        <div class='order-field-label'>
          Inscrição
        </div>
        <div class='order-field-value-total'>
          R$ {{ value_defaulting | currency:'BRL':'':'1.2-2'}}
        </div>
      </div>
      <div class='order-line'>
        <div class='order-field-label'>
          Total
        </div>
        <div class='order-field-value-total'>
          R$ {{ op2_value_total | currency:'BRL':'':'1.2-2'}}
        </div>
      </div>

      <div class='order-line'>
        <div class='order-field-label'>
        </div>
        <div class='order-field-value-total'>
          USD$ {{ op2_value_total_us | currency:'BRL':'':'1.2-2'}}
        </div>
      </div>

      <div class='option-button'>
        <button mat-raised-button (click)='getOptionTwo()' class='order-button'>
          Inscrever 2
        </button>
      </div>

    </div>

  </mat-card>
-->

  <!--
  <mat-card *ngIf="_caexService.currentProduct.id == 'CBCdc3adRHJc3vwDsJUr'">

    <div *ngFor="let spot of arrayHandsOnTopics" class='hands-on-line' (click)="getHandsOn(spot)">

      <div style="padding: 5px;">
        {{ spot.quantity}}/{{ spot.used}}
      </div>

      <div style="padding: 5px;">
        {{ spot.topic_name}}
      </div>

    </div>

  </mat-card>
-->

  <!--
  <mat-card *ngIf="_caexService.currentProduct.id == 'CBCdc3adRHJc3vwDsJUr' && handsOnTopicSelected">

    <div style="padding: 10px;">
      {{handsOnTopicSelected.topic_name}}
    </div>

  </mat-card>
  -->

</div>

<br><br><br><br>